import React from 'react';
import clamp from 'lodash/clamp';

import Markup from '../../markup';

function Count({ min, max, value, setValue }: { min: number, max: number, value: number, setValue: Function }) {

  return (
    <>
      <Markup.Global.Number.Container>
        <Markup.Global.Number.Button minus onClick={() => setValue(clamp(value - 1, min, max))} />
        <Markup.Global.Number.Value>{value}</Markup.Global.Number.Value>
        <Markup.Global.Number.Button onClick={() => setValue(clamp(value + 1, min, max))} />
      </Markup.Global.Number.Container>
    </>
  );
}

export default React.memo(Count);
